<!--  -->
<template>
  <div class="ae_box">
    <div class="tabselecr_box">
      <div class="selectionArea search_box">
        <!-- <el-input v-model="query.user_id" clearable style="width:200px;" placeholder="请输入员工id" /> -->
        <!-- <el-input v-model="query.corp_id" clearable style="width:200px;margin:0px 10px" placeholder="请输入公众号appid" /> -->
        <!-- <el-input v-model="query.suite_id" clearable style="width:200px;" placeholder="请输入应用id" /> -->
        <div class="item">
          <span class="title">员工编号:</span>
          <el-input
            v-model="query.employee_no"
            clearable
            style="width:280px;"
            placeholder="请输入员工编号"
          />
        </div>
        <div class="item">
          <span class="title">发言人员工编号:</span>
          <el-input
            v-model="query.spokesman_key_word"
            clearable
            style="width:280px;"
            placeholder="发言人员工编号"
          />
        </div>
        <div class="item">
          <span class="title">拉群规则/规则id:</span>
          <el-input
            v-model="query.group_chat_name_rule"
            clearable
            style="width:280px;"
            placeholder="拉群规则或者规则id搜索"
          />
        </div>
        <el-select
          v-model="query.onlyMe"
          placeholder="请选择"
        >
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchclick"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="rechargeclick"
          >重置</el-button>
        </div>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="add(1)"
        >新增</el-button>
        <el-button
          type="danger"
          :disabled="multipleSelection.length === 0"
          @click="ev_batchStopAutomatic"
        >批量关停</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      max-height="700"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column
        prop="source_text"
        label="来源类型"
        align="center"
        width="120"
      />
      <el-table-column
        prop="corp_user_name"
        label="员工名字(员工编号)"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          {{ scope.row.corp_user_name }} ({{ scope.row.employee_no }})
        </template>
      </el-table-column>
      <el-table-column
        prop="group_chat_name_rule"
        label="群名称(ID)"
        align="center"
        width="400"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="`${scope.row.group_chat_name_rule} (${scope.row.id})`"
            placement="top"
          >
            <div
              class="spokesman"
              style=" overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;vertical-align: middle;  max-width: 380px;"
            >
              {{ scope.row.group_chat_name_rule }} ({{ scope.row.id }})
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="group_chat_name_rule"
        label="发言人"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.namearr.toString()"
            placement="top"
          >
            <div class="spokesman">
              {{ scope.row.namearr.toString() }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="pull_user_wx_ids"
        label="拉人者"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <div style="display:flex;margin-right:10px;max-width:400px;overflow:hidden;">
            <div
              v-for="(v,i) in scope.row.pull_user_text"
              :key="i"
              style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="v.nickname"
                placement="top"
              >
                <span style="margin: 5px;"> {{ v.nickname }}</span>
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="pull_user_wx_ids"
        label="标签组"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div style="display:flex;margin-right:10px;max-width:400px;overflow:hidden;">
            <div
              v-for="(v,i) in scope.row.tag_ids_text"
              :key="i"
              style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="v.tag_name"
                placement="top"
              >
                <span style="margin: 5px;"> {{ v.tag_name }}</span>
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="rule_type_text"
        label="登录平台"
        align="center"
        width="150"
      />

      <el-table-column
        prop="chat_set_type_text"
        label="添加时间"
        align="center"
        width="150"
      />
      <el-table-column
        prop="max_number"
        label="最大人数上限"
        align="center"
        width="130"
      />
      <el-table-column
        prop="max_num_daily"
        label="每日群聊上限"
        align="center"
        width="130"
      />
      <el-table-column
        prop="chat_num"
        label="群数量"
        align="center"
        width="100"
      />
      <el-table-column
        prop="official_friend_num"
        label="官方好友数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="up_friend_num"
        label="真实好友数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
        width="100"
      />
      <el-table-column
        prop="updated_at_text"
        label="更新时间"
        align="center"
        width="100"
      />
      <el-table-column
        prop="user_id"
        label="自动建群"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div style="position: relative; display: inline-block;">
            <el-switch
              v-model="scope.row.automatic_group_chat"
              :width="60"
              active-color="#13ce66"
              inactive-color="rgb(191,191,191)"
              :active-value="2"
              :inactive-value="1"
              @change="changewr($event,scope.row)"
            />
            <div
              v-if="scope.row.automatic_group_chat === 1"
              style="color: #fff;position: absolute;top: 2px;right: 7px;"
            >关闭</div>
            <div
              v-else
              style="color: #fff;position: absolute;top: 2px;left: 7px;"
            >开启</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_id"
        label="自动拉人"
        align="center"
      >
        <template slot-scope="scope">
          <div style="position: relative; display: inline-block;">
            <el-switch
              v-model="scope.row.automatic_invite"
              :width="60"
              active-color="#13ce66"
              inactive-color="rgb(191,191,191)"
              :active-value="2"
              :inactive-value="1"
              @change="changewrr($event,scope.row)"
            />
            <div
              v-if="scope.row.automatic_invite === 1"
              style="color: #fff;position: absolute;top: 2px;right: 7px;"
            >关闭</div>
            <div
              v-else
              style="color: #fff;position: absolute;top: 2px;left: 7px;"
            >开启</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_id"
        label="填充旧群"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div style="position: relative; display: inline-block;">
            <el-switch
              v-model="scope.row.fill_groups"
              :width="60"
              active-color="#13ce66"
              inactive-color="rgb(191,191,191)"
              :active-value="2"
              :inactive-value="1"
              @change="changefillgroups($event,scope.row)"
            />
            <div
              v-if="scope.row.fill_groups === 1"
              style="color: #fff;position: absolute;top: 2px;right: 7px;"
            >关闭</div>
            <div
              v-else
              style="color: #fff;position: absolute;top: 2px;left: 7px;"
            >开启</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="130"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-dropdown
            trigger="click"
            placement="bottom"
            @command="(command)=>handleCommand(command,scope.row)"
          >
            <span
              class="el-dropdown-link"
              style="cursor: pointer;"
            >
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu>
              <div class="pullgroup-action-grid">
                <el-dropdown-item v-if="!external">
                  <el-button
                    class="butsize"
                    type="primary"
                    size="mini"
                    @click="pushgroup(scope.row.id)"
                  >拉群</el-button>
                </el-dropdown-item>
                <el-dropdown-item v-if="!external">
                  <el-button
                    class="butsize"
                    type="primary"
                    size="mini"
                    @click="pushpeo(scope.row.id)"
                  >拉人</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    class="butsize"
                    type="success"
                    size="mini"
                    @click="edit(2,scope.row)"
                  >编辑</el-button>
                </el-dropdown-item>
                <el-dropdown-item v-if="!external">
                  <el-button
                    class="butsize"
                    type="primary"
                    size="mini"
                    @click="configgroup(scope.row)"
                  >设置群主</el-button>
                </el-dropdown-item>
                <el-dropdown-item v-if="!external">
                  <el-button
                    class="butsize"
                    type="success"
                    size="mini"
                    @click="pullgroup(scope.row.id)"
                  >拉群进度</el-button>
                </el-dropdown-item>
                <el-dropdown-item v-if="!external">
                  <el-button
                    class="butsize"
                    type="primary"
                    size="mini"
                    @click="chatset(scope.row)"
                  >踢人规则</el-button>
                </el-dropdown-item>
                <el-dropdown-item v-if="!external">
                  <el-button
                    class="butsize"
                    type="success"
                    size="mini"
                    @click="addid(scope.row.id)"
                  >补充群id</el-button>
                </el-dropdown-item>
                <el-dropdown-item v-if="!external">
                  <el-button
                    class="butsize"
                    type="warning"
                    size="mini"
                    @click="laquhistory(scope.row.id)"
                  >拉群记录</el-button>
                </el-dropdown-item>
                <el-dropdown-item v-show="scope.row.rule_type === 2">
                  <el-button
                    class="butsize"
                    type="success"
                    size="mini"
                    @click="buildgroup(scope.row.id)"
                  >开始建群拉人</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    class="butsize"
                    type="info"
                    size="mini"
                    @click="clearInvitedCursor(scope.row.id)"
                  >清除邀请游标</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    class="butsize btn-purple"
                    type="primary"
                    size="mini"
                    @click="ev_quickPullGroup(scope.row)"
                  >快速拉群</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    class="butsize"
                    type="primary"
                    :disabled="scope.row.source != 2"
                    size="mini"
                    @click="ev_pullQwbChat(scope.row)"
                  >拉取外部构建群</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    class="butsize"
                    type="primary"
                    size="mini"
                    @click="reuse(3, scope.row)"
                  >复用</el-button>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10,20,50]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="{ add: '新增群设置', edit: '编辑群设置' ,reuse: '复用群设置'}[maintyep]"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="840px"
    >
      <pulldialog
        ref="pulldialogview"
        @updata="updata"
      />
    </el-dialog>

    <el-dialog
      title="本次拉群数量"
      :visible.sync="dialogVisibler"
      width="20%"
    >
      <el-input-number
        v-model="num"
        :min="1"
        :max="50"
        label="请输入本次拉群数量"
      />
      <div style="margin-top:20px">
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </div>

    </el-dialog>
    <el-dialog
      title="拉群进度"
      :visible.sync="dialogVisiblerpush"
      width="25%"
    >
      <pushchatsetid ref="pushchatsetidview" />
    </el-dialog>
    <el-dialog
      title="补充群id（企微宝）"
      :visible.sync="dialogVisiblerpushaddid"
      width="500px"
    >
      <el-form
        ref="ruleForm"
        status-icon
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="账号">
          <el-input
            v-model="account"
            placeholder="请输入账号"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addidqwb()"
          >提交</el-button>
        </el-form-item>
      </el-form></el-dialog>
    <el-dialog
      title="选择群主"
      :visible.sync="dialogConfigGroup"
      :destroy-on-close="true"
      width="40%"
      @close="close"
    >
      <groupOwner
        ref="groupOwner"
        @updata="closeout"
      />
    </el-dialog>
    <el-dialog
      title="踢人规则（只对小程序有效）"
      :visible.sync="dialogthreshold"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <settingthreshold
        ref="settingthresholdview"
        @setawrthreshold="setawrthreshold"
      />
    </el-dialog>
    <el-dialog
      title="选择发言人"
      :visible.sync="dialogPullQwbChat"
      width="400px"
      :close-on-click-modal="false"
      @closed="resetPullQwbChatDialog"
    >
      <el-select
        v-model="pullQwbSelectedFriendId"
        placeholder="请选择发言人"
        clearable
        style="width: 100%;"
      >
        <el-option
          v-for="(item, index) in pullQwbSpokesmanList"
          :key="index"
          :label="item.nickname"
          :value="item.friend_id"
        />
      </el-select>
      <div slot="footer">
        <el-button type="primary" @click="confirmPullQwbChat">确定</el-button>
        <el-button @click="dialogPullQwbChat = false">取消</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import groupOwner from './components/groupOwner.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { groupChatSetindex, editAutomaticTypewe, startCreateChat, startInvite, supplementUpChatroomId, supplementUpChatroomIdQwb, startbuild, clearCursor, batchStopAutomatic, quickPullGroup, pullQwbChat } from '@/api/officialaccount.js'
import pulldialog from './components/pulldialog.vue'
import pushchatsetid from './components/pushchatsetid.vue'
import settingthreshold from './components/settingthreshold.vue'
export default {
  components: { PaginationRight, pulldialog, pushchatsetid, groupOwner, settingthreshold },
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      external: false,
      total: null,
      loading: false,
      query: {
        page: 1,
        page_size: 10,
        employee_no: null,
        onlyMe: 2,
        spokesman_key_word: null,
        group_chat_name_rule: ''
        // user_id: null,
        // corp_id: null
      },
      dialogVisible: false,
      chat_set_id: null,
      dialogVisibler: false,
      num: null,
      dialogVisiblerpush: false,
      dialogConfigGroup: false,
      accountarr: [
        {
          value: 1,
          label: '查看组内拉群规则'
        },
        {
          value: 2,
          label: '我授权的拉群规则'
        }
      ],
      dialogthreshold: false,
      maintyep: null,
      account: null,
      dialogVisiblerpushaddid: false,
      dialogPullQwbChat: false,
      pullQwbSpokesmanList: [],
      pullQwbSelectedFriendId: null,
      pullQwbChatSetId: null
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    ev_quickPullGroup(row) {
      this.$confirm('是否进行快速拉群？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'pullgroup-quick-confirm'
      })
        .then(() => {
          quickPullGroup({
            chat_set_id: row.id
          }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg || '快速拉群成功')
              this.list()
            }
          })
        })
        .catch(() => {})
    },
    ev_pullQwbChat(row) {
      const spokesman_user_text = row.spokesman_user_text || []
      if (!spokesman_user_text.length) {
        this.$message.error('暂无发言人，无法拉取外部构建群')
        return
      }
      this.pullQwbChatSetId = row.id
      this.pullQwbSpokesmanList = spokesman_user_text
      this.pullQwbSelectedFriendId = null
      this.dialogPullQwbChat = true
    },
    resetPullQwbChatDialog() {
      this.pullQwbSpokesmanList = []
      this.pullQwbSelectedFriendId = null
      this.pullQwbChatSetId = null
    },
    confirmPullQwbChat() {
      if (!this.pullQwbSelectedFriendId) {
        this.$message.error('请选择发言人')
        return
      }
      pullQwbChat({
        chat_set_id: this.pullQwbChatSetId,
        wx_id: this.pullQwbSelectedFriendId
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg || '拉取外部构建群成功')
          this.dialogPullQwbChat = false
          this.list()
        }
      })
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    async ev_batchStopAutomatic() {
      await batchStopAutomatic({
        ids: this.multipleSelection.map(item => item.id)
      })
      this.$message.success('批量关停成功')
      this.list()
    },
    addid(chat_set_id, type) {
      console.log('type:', type)
      if (type === 3) {
        this.dialogVisiblerpushaddid = true
        this.chat_set_id = chat_set_id
      } else {
        // this.$confirm('确认补充群id？')
        //   .then(async () => {
        //     const res = await supplementUpChatroomId({
        //       chat_set_id
        //     })
        //     console.log('res:', res)
        //     if (res.code === 200) {
        //       this.$message.success('补充id成功')
        //     }
        //   })
        //   .catch(_ => {})
        this.$confirm('确认补充群id？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            //     const res = await supplementUpChatroomId({
            //       chat_set_id
            //     })
            //     console.log('res:', res)
            //     if (res.code === 200) {
            //       this.$message.success('补充id成功')
            //     }
            supplementUpChatroomId({
              chat_set_id: chat_set_id
            }).then(res => {
              if (res.code === 200) {
                this.$message.success('补充id成功')
              }
            })
          })
          .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });
          })
      }
    },
    async addidqwb() {
      console.log('this.account:', this.account)
      if (this.account === null) {
        this.$message({
          message: '请输入账号',
          type: 'success'
        })
        return
      }
      const res = await supplementUpChatroomIdQwb({
        chat_set_id: this.chat_set_id,
        account: this.account
      })
      console.log('res:', res)
      if (res.code === 200) {
        this.$message.success('补充id成功')
      }
    },
    handleCommand(command, data) {
      console.log(command, data, '111111')
    },
    closeout() {
      this.dialogConfigGroup = false
    },
    close() {
      this.$refs.groupOwner.close()
    },
    configgroup(row) {
      console.log('id:', row)
      this.dialogConfigGroup = true
      this.$nextTick(() => {
        this.$refs.groupOwner.send(2, row)
      })
    },
    async list() {
      this.loading = true
      const data = await groupChatSetindex(this.query)

      data.data.list.forEach(element => {
        element.namearr = []
        element.spokesman_user_text.forEach(item => {
          element.namearr.push(item.nickname)
        })
      })
      this.tableData = data.data.list
      this.external = data.data.external
      this.total = data.data.total
      this.loading = false
      console.log('data', this.tableData)
    },
    open(id) {
      this.query.corp_id = id
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.page = 1
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.employee_no = null
      this.query.onlyMe = 2
      this.query.spokesman_key_word = null
      this.query.group_chat_name_rule = ''
      // this.query.user_id = null
      this.list()
    },
    reuse(type, item) {
      this.maintyep = 'reuse'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.pulldialogview.send(type, item, this.query.onlyMe, this.external)
      })
    },
    add(type, item) {
      this.maintyep = 'add'
      this.dialogVisible = true
      if (type === 1) {
        this.$nextTick(() => {
          this.$refs.pulldialogview.send(type, null, this.query.onlyMe, this.external)
        })
      }
    },
    edit(type, item) {
      this.maintyep = 'edit'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.pulldialogview.send(type, item, this.query.onlyMe, this.external)
      })
    },
    async changewr(val, item) {
      console.log(val, item)
      await editAutomaticTypewe({
        automatic_group_chat: val,
        id: item.id
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    async changewrr(val, item) {
      console.log(val, item)
      await editAutomaticTypewe({
        automatic_invite: val,
        id: item.id
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    async changefillgroups(val, item) {
      console.log(val, item)
      await editAutomaticTypewe({
        fill_groups: val,
        id: item.id
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    updata() {
      this.dialogVisible = false
      this.list()
    },
    pushgroup(id) {
      this.num = null
      this.chat_set_id = id
      this.dialogVisibler = true
    },
    async sumbitr() {
      if (this.num === undefined) {
        this.$message({
          message: '请输入拉取群数量',
          type: 'error'
        })
        return
      }
      const data = await startCreateChat({
        chat_set_id: this.chat_set_id,
        chat_num: this.num
      })
      this.$message({
        message: '拉取成功',
        type: 'success'
      })
      this.dialogVisibler = false
      console.log('data', data)
    },
    async pushpeo(id) {
      this.chat_set_id = id
      const data = await startInvite({
        chat_set_id: this.chat_set_id
      })
      console.log('data', data)
      this.$message({
        message: '拉取成功',
        type: 'success'
      })
    },
    pullgroup(chat_set_id) {
      this.dialogVisiblerpush = true
      this.$nextTick(() => {
        this.$refs.pushchatsetidview.send(chat_set_id)
      })
      console.log('chat_set_id', chat_set_id)
    },
    chatset(item) {
      this.dialogthreshold = true
      this.$nextTick(() => {
        this.$refs.settingthresholdview.send(item)
      })
    },
    setawrthreshold() {
      this.dialogthreshold = false
      this.list()
    },
    laquhistory(chat_set_id) {
      console.log('chat_set_id', chat_set_id)
      this.$router.push({
        name: 'Wechatlist',
        params: {
          chat_set_id: chat_set_id
        }
      })
    },
    async buildgroup(id) {
      await startbuild({ chat_set_id: id })
      this.$message({
        message: '拉取成功',
        type: 'success'
      })
    },
    async clearInvitedCursor(id) {
      const data = await clearCursor({ chat_set_id: id })
      if (data.code === 200) {
        this.$message({
          message: '清除成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: data.message,
          type: 'error'
        })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box {
  text-align: center;
}
.ae_box {
  padding: 30px;
}
.spokesman {
  max-width: 260px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.butsize {
  width: 120px;
}
.btn-purple.el-button--primary {
  background-color: #9333ea;
  border-color: #9333ea;
}
.btn-purple.el-button--primary:hover,
.btn-purple.el-button--primary:focus {
  background-color: #7e22ce;
  border-color: #7e22ce;
}
.btn-purple.el-button--primary:active {
  background-color: #6b21a8;
  border-color: #6b21a8;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(33.33% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}
@media (max-width: 768px){
  .el-dropdown-menu__item button{
    width:100%;
    height:8vw;
    margin:1vw 0vw;
    font-size:3vw !important;
  }
}
.pullgroup-action-grid {
  display: flex;
  flex-wrap: wrap;
  width: 275px;
  gap: 8px;
  .el-dropdown-menu__item {
    padding: 0 6px;
  }
}
</style>

<style>
/* MessageBox 挂到 body，需非 scoped；确定在左、取消在右 */
.pullgroup-quick-confirm .el-message-box__btns {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  gap: 10px;
}
</style>
